// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"107":"a6368561","283":"1790cbcd","291":"2c90eeac","302":"37d52747"}[chunkId] + ".chunk.js";
};